import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'An author deleted a content block from a collection share link page',
  name: 'block_deleted',
};

export default META;
